import React, {useEffect, useState} from "react";
import _ from "underscore";
import {authCheck, getImageSize, mustShowExtraTag} from "../../common/utils"
import config from "../../../config";
import Button from "react-bootstrap/Button";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {deleteFavorite, deleteFavoriteFromB2bCollection, saveFavorite} from "../../actionCreators/favoritesAC";
import {renderAuthPopup} from "../../actionCreators/pdpAC";
import Image from "react-bootstrap/Image";
import {filterPromoMessages} from "../../actionCreators/appAC";
import ReactHtmlParser from "react-html-parser";
import LazyLoad, { forceCheck } from 'react-lazyload';
import PLPInnerBanner from "../../PLP/PLPInnerBanner";
import FirstLookPreviewOverlay from "../../PLP/FirstLookPreviewOverlay";
import RewardsPlusPricesPLP from "../../PLP/rewards-plus/RewardsPlusPricesPLP";
import { HeartActive, HeartIcon } from "../../common/Icons";

const ProductVariation = React.memo(({product_variation, alt_prefix, listingMode, is_product_favorite, collection_id, plpMode, idx, is_b2b, is_wholesale_active, force_lazyload, customClass, filtersHiddenDesktop }) => {
    const dispatch = useDispatch();
    const {promo_messages, profileFavorites, init} = useSelector((state) => ({
        profileFavorites: state.myAccountReducer.profileFavorites,
        init: state.appReducer.init,
        promo_messages: state.appReducer.promo_messages,
    }), shallowEqual);
    const {extra_tags_map} = init;
    const [favoriteClicked, setFavoriteClicked] = useState(false);
    const { product_url, url, image, title, id, tags, availableForSale, has_pricedrop_tag, wholesaleTag, productTag, condition_label, item_size } = product_variation;
    const isFavorite = is_product_favorite || !!_.find(profileFavorites, (favoriteId) => {
        return id === favoriteId;
    });

    useEffect(() => {
        setFavoriteClicked(isFavorite);
        if (force_lazyload) {
            forceCheck();
        }
    }, [isFavorite]);

    const wholesaleDiscountsFilterObj = config.wholesaleDiscountsFilters;
    const favCountNumber = (product_variation && parseInt(product_variation.favorites_count)) || 0;
    const favCountLocal = parseInt(localStorage.getItem(`fav_count_${id}`));
    const favCount = favCountLocal || favCountNumber;

    useEffect(() => {
        if (favCountNumber >= favCountLocal) {
            localStorage.removeItem(`fav_count_${id}`);
        }
    }, [favCountNumber]);

    const product_variation_url = (product_url || url) + '?groupBy=productClicked';

    const manageFavorites = (product_id) => {
        if (authCheck()) {
            if(favoriteClicked) {
                setFavoriteClicked(false);
                if(is_b2b && collection_id){
                    dispatch(deleteFavoriteFromB2bCollection(product_id, collection_id))
                } else {
                    dispatch(deleteFavorite(product_id, favCount));
                }
            } else {
                if (!is_b2b) {
                    setFavoriteClicked(true);
                }
                dispatch(saveFavorite(product_id, favCount));
            }
        } else {
            sessionStorage.setItem("clicked_product_id", product_id);
            dispatch(renderAuthPopup('signup', saveFavoritesAfterAuth, "Create an account to keep track of your saved items"));
        }
    }

    const saveFavoritesAfterAuth = () => {
        const clicked_product_id = parseInt(sessionStorage.getItem("clicked_product_id"));
        manageFavorites(clicked_product_id, true);
    }

    const condition_or_size_label = `${condition_label ? condition_label : ""}${condition_label && !item_size ? " Condition" : ""}${condition_label && item_size ? " | " : ""}${item_size ? `Size ${item_size}` : ""}`;
    const show_extra_tag = productTag ? mustShowExtraTag(productTag, has_pricedrop_tag, is_b2b) : false;

    let bannerLabel = "";

    if (availableForSale) {
        if (is_wholesale_active && wholesaleTag) {
            bannerLabel = wholesaleDiscountsFilterObj[wholesaleTag];
        } else if (show_extra_tag) {
            bannerLabel = extra_tags_map[productTag];
        }
    }
    const promoMessage = filterPromoMessages(promo_messages, tags, "show_in_plp");

    return (
        <>
            <PLPInnerBanner
                idx={idx}
                plpMode={plpMode}
                filtersHiddenDesktop={filtersHiddenDesktop}
            />
            <div
                className={`${customClass ? customClass : ""} ${plpMode ? `plp__product plp-product plp-product-${idx} ${product_variation.firstLookProduct ? "plp__first-look-preview" : ""}` : ""}`}
                data-product-id={id}
            >
                <FirstLookPreviewOverlay
                    plpMode={plpMode}
                    productHandle={product_variation.handle}
                    firstLookProduct={product_variation.firstLookProduct}
                />
                <a
                    className={`${plpMode ? "plp__card" : "products-carousel__card"} ${listingMode ? "products-carousel__card--slim" : ""} ${!availableForSale ? "products-carousel__card--sold-out" : ""} card`}
                    href={product_variation_url}
                >
                    <div className="products-carousel__card-header">
                        <div className="pdp__banner-container">
                            {availableForSale &&
                            <div className="products-carousel__tag">{bannerLabel}</div>
                            }
                            {!availableForSale &&
                            <div className="pdp__sold-out-label pdp__sold-out-label--carousel">Sold</div>
                            }
                        </div>
                        {id &&
                            <Button
                                className="products-carousel__favorite-container"
                                aria-label="Favorite"
                                data-product-id={id}
                                onClick={
                                    (event) => {
                                        event.preventDefault();
                                        event.stopPropagation();
                                        if (is_b2b && collection_id) {
                                            manageFavorites(id, collection_id)
                                        } else {
                                            if(manageFavorites){
                                                manageFavorites(id, !favoriteClicked);
                                            }
                                        }
                                    }
                                }
                                variant="clean"
                            >
                                {!collection_id ?
                                    <span className="pdp__favorite-cta favorite-inner">
                                        {favoriteClicked ?
                                            <HeartActive
                                                className="products-carousel__item-favorite-icon"
                                                label="Favorite"
                                                style={{width: 22}}
                                            />
                                            :
                                            <HeartIcon
                                                style={{width: 22}}
                                                className="products-carousel__item-favorite-icon"
                                                label="Favorite"
                                            />
                                        }
                                        {favCount > 1 &&
                                            <span className="products-carousel__favorite-container--counter">
                                                {favCount}
                                            </span>
                                        }
                                    </span>
                                    :
                                    <span className="icon-trash products-carousel__favorite-container--delete" />
                                }
                            </Button>
                        }
                    </div>
                    <div className="products-carousel__image-wrapper">
                        <LazyLoad height={380} offset={100} once={true} overflow={customClass === "search-menu__product"}>
                            <Image
                                src={image ? getImageSize(image, config.image_sizes.medium) : config.PLACE_HOLDER}
                                alt={`${alt_prefix ? alt_prefix : ""} ${title}`}
                                className="products-carousel__card-image"
                                width="300"
                                height="300"
                            />
                        </LazyLoad>
                    </div>
                    <div className="products-carousel__card-body">
                        <div className="products-carousel__card-title-container">
                            <div className="products-carousel__card-designer">{product_variation.vendor}</div>
                            <span className="products-carousel__card-title" title={product_variation.title}>{product_variation.title}</span>
                        </div>
                        <div className="products-carousel__card-details">
                            {condition_or_size_label &&
                            <span className="products-carousel__card-condition">
                                {condition_or_size_label}
                            </span>
                            }
                            {customClass !== "search-menu__product" &&
                                <RewardsPlusPricesPLP
                                    product={product_variation}
                                />
                            }
                            {promoMessage && promoMessage.length > 0 && plpMode &&
                            <div className="products-carousel__promo-message">
                                {ReactHtmlParser(promoMessage[0]?.message)}
                            </div>
                            }
                        </div>
                    </div>
                </a>
            </div>
        </>
    )
});

export default ProductVariation;